export interface RazBook {
  id: string;
  title: string;
  pdf?: string;
  audio?: string;
  video?: string;
}
export interface RazManifest {
  version: 1;
  level: "A";
  books: RazBook[];
  collectionAudio?: string;
}
export function isRazMediaKey(key: string): boolean {
  return /^A\/(?:\d{2,}\/(?:book\.pdf|audio\.mp3|video\.mp4)|collection\.mp3)$/.test(key);
}
export function parseRazManifest(value: unknown): RazManifest {
  if (!value || typeof value !== "object") throw new Error("RAZ 清单格式错误");
  const m = value as Partial<RazManifest>;
  if (m.version !== 1 || m.level !== "A" || !Array.isArray(m.books) || m.books.length > 1000) throw new Error("RAZ 清单格式错误");
  const ids = new Set<string>();
  for (const b of m.books) {
    if (!b || typeof b.id !== "string" || !/^\d{2,}$/.test(b.id) || Number(b.id) < 1 || ids.has(b.id) || typeof b.title !== "string" || !b.title.trim()) throw new Error("RAZ 条目格式错误");
    ids.add(b.id);
    for (const [kind, file] of [["pdf", "book.pdf"], ["audio", "audio.mp3"], ["video", "video.mp4"]] as const) {
      if (b[kind] !== undefined && b[kind] !== `A/${b.id}/${file}`) throw new Error("RAZ 资源路径错误");
    }
    if (!b.pdf && !b.audio && !b.video) throw new Error("RAZ 条目没有资源");
  }
  if (m.collectionAudio !== undefined && m.collectionAudio !== "A/collection.mp3") throw new Error("RAZ 合集路径错误");
  return m as RazManifest;
}
